import React from 'react';
import StatusbarConstants from '../../../../constants/statusbar_constants';
import { MissingDimensions } from './missing_dimensions';
import { MissingLoadIndex } from './missing_load_index';
import { MissingPostcode } from './missing_postcode';
import { MissingSpeedIndex } from './missing_speed_index';
import { MissingTyreIndex } from './missing_tyre_index';
import { MissingTyreIndexAndPassword } from './missing_tyre_index_and_postcode';
import { NoneGiven } from './none_given';
import { AllGiven } from './all_given';

function getMissingStatusComponent(status, onClick, onLearnMoreClick) {
    switch (status) {
        case StatusbarConstants.DIMENSIONS_MISSING:
            return <MissingDimensions onClick={onClick} />;
        case StatusbarConstants.TYRE_INDEX_AND_POSTCODE_MISSING:
            return <MissingTyreIndexAndPassword onClick={onClick} />;
        case StatusbarConstants.SPEED_INDEX_MISSING:
            return <MissingSpeedIndex onClick={onClick} />;
        case StatusbarConstants.LOAD_INDEX_MISSING:
            return <MissingLoadIndex onClick={onClick} />;
        case StatusbarConstants.TYRE_INDEX_MISSING:
            return <MissingTyreIndex onClick={onClick} />;
        case StatusbarConstants.POSTCODE_MISSING:
            return <MissingPostcode onClick={onClick} />;

        case StatusbarConstants.NONE_MISSING:
            return <AllGiven onLearnMoreClick={onLearnMoreClick} />;
        case StatusbarConstants.ALL_MISSING:
            /* falls through */
        default:
            return <NoneGiven onClick={onClick} />;
    }
}

export { getMissingStatusComponent };